// extracted by mini-css-extract-plugin
export default {"indicator-bar":"u5MR0c5","indicator-bar__progress":"Isgs2aM","indicator-bar__triangle":"NbxxVKl"};